
import { computed, defineComponent } from 'vue'

export default defineComponent({
  props: {
    mainButton: { type: Boolean, required: false },
    dangerButton: { type: Boolean, required: false },
    loading: { type: Boolean, required: false },
    // Generic gate — the parent decides (e.g. from a permission composable).
    // Kept role-agnostic so this primitive knows nothing about permissions.
    allowed: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    disabledTooltip: { type: String, default: '' }
  },
  setup(props) {
    const isDisabled = computed(
      () => props.loading || props.disabled || !props.allowed
    )

    return { isDisabled }
  }
})
